export function makePageSingleton<I>(createInstance: () => I): () => I {
  let instance: I | null

  // Reset instance when Turbolinks navigates to a new page
  window.addEventListener('turbolinks:before-visit', () => {
    instance = null
  })

  const setupInstance = (): I => {
    instance = createInstance()
    return instance
  }

  const getInstance = (): I => {
    return instance ? instance : setupInstance()
  }

  return getInstance
}
